<div class="no-data-container">
  <img src="/assets/nodata.png" />
  <p class="no-data-text">{{ "No data available" | transloco }}</p>
</div>